<template>
  <b-modal id="apply-deposit-match-modal" hide-footer size="sm" centered @show="fetchPromotionList(1, '')">
    <template #modal-title>
      <div class="d-flex align-items-center">
        <span class="font-weight-bold">Apply Deposit Match</span>
        <b-icon-gift class="ml-1 text-primary"></b-icon-gift>
      </div>
    </template>

    <!-- Subtitle -->
    <div class="text-center mb-1">
      <h5 class="font-weight-bold mb-0 text-black">Select Deposit Match</h5>
      <small class="text-muted">
        Choose from available deposit match templates to apply.
      </small>
    </div>

    <!-- Select -->
    <b-form-group label="Deposit Match" label-class="text-black">
      <v-select
        ref="depositMatchSelect"
        v-model="option"
        :options="sortedOptions"
        :reduce="(val) => val.value"
        label="text"
        placeholder="Select Deposit Match"
        :filterable="false"
        :loading="loadingSearch"
        :selectable="(option) => !option.isHeader"
        @search="onSearch"
        @open="onDropdownOpen"
        @close="onDropdownClose"
        class="deposit-match-select"
      >
        <template #option="item">
          <div class="d-flex align-items-center justify-content-between">
            <span v-if="item.isHeader" class="text-muted font-weight-bold small text-uppercase">
              {{ item.text }}
            </span>
            <template v-else>
              <span>{{ item.text }}</span>
              <span
                class="favorite-star ml-1"
                @mousedown.stop.prevent="toggleFavorite(item)"
              >
                <b-icon-star-fill v-if="item.isFavorite" class="text-warning" />
                <b-icon-star v-else class="text-muted" />
              </span>
            </template>
          </div>
        </template>
        <template #list-footer>
          <li v-if="hasMore" ref="loadMoreTrigger" class="vs__load-more text-center py-1">
            <b-spinner v-if="loadingMore" small class="my-1" />
          </li>
        </template>
        <template #no-options>
          <span v-if="loadingSearch">Searching...</span>
          <span v-else>No deposit matches found.</span>
        </template>
      </v-select>
    </b-form-group>

    <!-- Description -->
    <b-form-group label="Description" class="text-black">
      <b-form-textarea
        v-model="description"
        placeholder="Description will appear after deposit match selected"
        disabled
        rows="3"
      />
    </b-form-group>

    <!-- Buttons -->
    <b-button
      block
      variant="success"
      class="mb-1 mt-2"
      @click="handleApplyPromotion"
      :disabled="loadingCreatePromotion || !option"
    >
      <Spinner v-if="loadingCreatePromotion" />
      <template v-else> APPLY DEPOSIT MATCH</template>
    </b-button>

    <b-button
      block
      variant="secondary"
      class="mb-1"
      @click="$bvModal.show('promo')"
    >
      CREATE DEPOSIT MATCH
    </b-button>

    <b-button block variant="outline-secondary" @click="hideModal">
      CANCEL
    </b-button>

    <!-- CREATE NEW PROMOTION -->
    <b-modal id="promo" hide-footer size="md" centered>
      <template #modal-title>
        <div class="d-flex align-items-center">
          <span class="font-weight-bold">Create New Deposit Match</span>
          <b-icon-gift class="ml-1 text-primary"></b-icon-gift>
        </div>
      </template>
      <div class="text-body">
        <b-row>
          <b-col cols="12">
            <p class="font-weight-bold mb-0">Promotion Name</p>
            <b-form-input
              placeholder="June 100% Deposit Bonus"
              v-model="form.name"
              type="text"
            />
          </b-col>
          <b-col cols="12" class="mt-1">
            <p class="font-weight-bold mb-0">Internal Reference Code</p>
            <b-form-input
              placeholder="JUNE100"
              v-model="form.code"
              type="text"
            />
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols="12">
            <p class="font-weight-bold mb-0">Promotion Description</p>
            <b-form-textarea
              v-model="form.description"
              placeholder="Get a 100% match when you deposit up to $500 for a limited time!"
              rows="1"
              no-resize
            ></b-form-textarea>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols="6">
            <p class="font-weight-bold mb-0">Start Date</p>
            <flat-pickr
              id="startDate"
              v-model="form.openDate"
              class="form-control"
              :config="configDate"
              placeholder="mm/dd/yyyy"
            />
          </b-col>
          <b-col cols="6">
            <p class="font-weight-bold mb-0">End Date</p>
            <flat-pickr
              id="endDate"
              v-model="form.closeDate"
              class="form-control"
              :config="configDate"
              placeholder="mm/dd/yyyy"
            />
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <p class="font-weight-bold mb-0">Match Percentage*</p>
            <b-input-group size="md" append="%">
              <b-form-input
                v-model="form.discountValue"
                value="20"
                min="1"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="6">
            <p class="font-weight-bold mb-0">Maximum Match Amount*</p>
            <b-input-group size="md" prepend="$">
              <b-form-input
                v-model="form.maxDiscount"
                value="500"
                min="1"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols="12">
            <p class="font-weight-bold mb-0">Accumulator</p>
            <v-select
              v-model="form.subType"
              :options="optionsType"
              :reduce="(val) => val.value"
              :clearable="false"
              @input="(val) => (option = val.value)"
              class="w-100"
            />
          </b-col>
          <b-col cols="12" class="mt-1">
            <p class="font-weight-bold mb-0">
              How Many Days for the Bonus Bets left to expire
            </p>
            <b-form-input
              type="number"
              v-model.number="form.bonusExpiredDays"
              :min="1"
              :step="1"
            />
          </b-col>
        </b-row>
      </div>

      <b-button
        block
        variant="primary"
        class="mb-1 mt-1"
        @click="handleCreateNewPromo"
        :disabled="loadingCreatePromotion"
      >
        <Spinner v-if="loadingCreatePromotion" />
        <template v-else> EDIT</template>
      </b-button>
    </b-modal>
  </b-modal>
</template>

<script>
import Spinner from "@/@core/components/Spinner.vue";
import useToastHandler from "@/services/toastHandler";
import {
  BButton,
  BModal,
  BFormGroup,
  BFormSelect,
  BFormSelectOption,
  BFormTextarea,
  BIconGift,
  BIconStar,
  BIconStarFill,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import { formatDateSend } from "@/helpers/utils";

const FAVORITES_STORAGE_KEY = "deposit-match-favorites";
const PAGE_LIMIT = 20;

export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    BFormTextarea,
    BIconGift,
    BIconStar,
    BIconStarFill,
    Spinner,
    BRow,
    BCol,
    flatPickr,
    BFormInput,
    BInputGroup,
    BSpinner,
    vSelect,
  },
  data() {
    return {
      option: null,
      description: "",
      allOptions: [],
      totalItems: 0,
      currentPage: 1,
      loadingSearch: false,
      loadingMore: false,
      searchQuery: "",
      searchTimeout: null,
      observer: null,
      form: {
        name: "",
        code: "",
        description: "",
        openDate: "",
        closeDate: "",
        bonusExpiredDays: null,
        type: "deposit",
        maxDiscount: "",
        discountValue: "",
        subType: null,
      },
      optionsType: [
        { label: "Yes - Accumulative", value: "Recurring Deposit" },
        { label: "No - Once Off Deposit", value: "One-time Deposit" },
      ],
      max: 4,
      value: 2,
      configDate: {
        enableTime: true,
        enableSeconds: true,
        altInput: true,
        altFormat: "d-m-Y H:i:S",
        dateFormat: "Y-m-d H:i:S",
        static: true,
      },
    };
  },
  computed: {
    ...mapState("promotions/list", ["loadingCreatePromotion"]),
    hasMore() {
      return this.allOptions.length < this.totalItems;
    },
    sortedOptions() {
      return this.allOptions;
    },
  },
  watch: {
    option(val) {
      if (val) {
        const item = this.allOptions.find((i) => i.value === val);
        this.description = item ? item.description : "";
      } else {
        this.description = "";
      }
    },
  },
  async created() {},
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    ...mapActions({
      getPromotionsList: "promotions/list/getPromotionsList",
      getDetailPromotion: "promotions/list/getDetailPromotion",
      updatePromotionTargets: "promotions/list/updatePromotionTargets",
      createNewPromotion: "promotions/list/createNewPromotion",
      setReloadListDepositMatches: "promotions/list/setReloadListDepositMatches",
      fetchUser: "user/detail/asyncUser",
      updatePromotion: "promotions/list/updatePromotion",
    }),
    async fetchPromotionList(page, search) {
      if (page === 1) this.loadingSearch = true;
      else this.loadingMore = true;

      const data = await this.getPromotionsList({
        page,
        limit: PAGE_LIMIT,
        type: "Deposit",
        onlyActive: true,
        ...(search ? { search } : {}),
      });

      if (page === 1) this.loadingSearch = false;
      else this.loadingMore = false;

      if (!data) return this.showToastError(false, "Error fetching promotion list");

      this.totalItems = data.pagination?.total ?? data.data.length;

      const list = data.data.map((i) => ({
        ...i,
        value: i.id,
        text: i.name,
      }));

      if (page === 1) {
        this.allOptions = list;
      } else {
        this.allOptions.push(...list);
      }
    },
    onSearch(query) {
      if (query === this.searchQuery) return;
      this.searchQuery = query;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.fetchPromotionList(1, query);
      }, 300);
    },
    getDropdownMenu() {
      return this.$refs.depositMatchSelect?.$el?.querySelector('.vs__dropdown-menu');
    },
    async loadMore() {
      if (this.loadingMore || !this.hasMore) return;
      this.currentPage++;
      const menu = this.getDropdownMenu();
      const scrollTop = menu ? menu.scrollTop : 0;
      await this.fetchPromotionList(this.currentPage, this.searchQuery);
      this.$nextTick(() => {
        const m = this.getDropdownMenu();
        if (m) m.scrollTop = scrollTop;
        this.observeLoadMore();
      });
    },
    observeLoadMore() {
      if (this.observer) {
        this.observer.disconnect();
      }
      const el = this.$refs.loadMoreTrigger;
      if (!el) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.loadMore();
          }
        },
        { root: el.closest(".vs__dropdown-menu"), threshold: 0 }
      );
      this.observer.observe(el);
    },
    async onDropdownOpen() {
      this.searchQuery = "";
      this.currentPage = 1;
      await this.fetchPromotionList(1, "");
      this.$nextTick(() => this.observeLoadMore());
    },
    onDropdownClose() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
    async toggleFavorite(item) {
      const newFavorite = !item.isFavorite;
      const menu = this.getDropdownMenu();
      const scrollTop = menu ? menu.scrollTop : 0;
      const idx = this.allOptions.findIndex((o) => o.value === item.value);
      if (idx !== -1) {
        this.$set(this.allOptions, idx, { ...this.allOptions[idx], isFavorite: newFavorite });
      }
      this.$nextTick(() => {
        const m = this.getDropdownMenu();
        if (m) m.scrollTop = scrollTop;
      });
      this.updatePromotion({ promotionId: item.value, isFavorite: newFavorite });
    },
    async handleApplyPromotion() {
      const res = await this.updatePromotionTargets({
        promotionId: this.option,
        targets: [
          {
            targetType: "User",
            targetId: this.$router.currentRoute.params.id,
          },
        ],
      });
      if (res) {
        this.showToastSuccess(true, "Applied successfully!");
        this.hideModal();
        this.setReloadListDepositMatches(true);
        this.fetchUser({ id: this.$router.currentRoute.params.id });
      }
    },
    hideModal() {
      this.$bvModal.hide("apply-deposit-match-modal");
      this.$bvModal.hide("promo");
      this.option = null;
      this.description = "";
      this.form = {
        name: "",
        code: "",
        description: "",
        openDate: "",
        closeDate: "",
        bonusExpiredDays: null,
        type: "deposit",
        maxDiscount: "",
        discountValue: "",
        subType: null,
      };
    },
    async handleCreateNewPromo() {
      const res = await this.createNewPromotion({
        name: this.form.name,
        code: this.form.code,
        description: this.form.description,
        type: "Deposit",
        subType: this.form.subType,
        discountValue: Number(this.form.discountValue),
        maxDiscount: Number(this.form.maxDiscount),
        status: "active",
        startTime: this.formatDateSend(this.form.openDate),
        endTime: this.formatDateSend(this.form.closeDate),
        bonusExpiredDays: this.form.bonusExpiredDays,
        discountType: 'deposit-bonus',
        targets: [
          {
            targetType: "User",
            targetId: this.$router.currentRoute.params.id,
          },
        ],
      });
      if (res.data) {
        this.showToastSuccess(true, "Promotion created successfully!");
        this.hideModal();
        this.setReloadListDepositMatches(true);
      }
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
      formatDateSend,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.deposit-match-select {
  .vs__dropdown-option--disabled {
    opacity: 1;
    cursor: default;
    padding: 4px 12px;
    background: transparent;
  }

  .favorite-star {
    cursor: pointer;
    line-height: 1;
  }

  .vs__load-more {
    list-style: none;
    border-top: 1px solid #ebe9f1;
  }
}
</style>